import React, { useEffect, useState } from 'react';
import { Card, CardBody, Container } from "reactstrap";
import Breadcrumb from "Components/UI/Breadcrumb";
import PaginatedTable from "Components/Tables/PaginatedTable";
import { Link } from 'react-router-dom';
import useTableFilters from 'helpers/hooks/useTableFilters';
import { deleteBookingPermanently, getBookings, restoreBooking } from 'helpers/API Calls/Operations/booking';
import Spinner from 'Components/UI/Spinner';
import convertDateFormat from 'Components/Date/DateFormat';
import DeleteModal from 'Components/Modals/DeleteModal';
import { generateQueryParams } from 'helpers/queryParams';
import { getStatusBadge } from './Bookings/status';
import ConformationModal from 'Components/Modals/ConformationModal';

const tableHead = [
  { id: 1, name: "#", isSortable: true, key: "id" },
  { id: 3, name: "Customer", isSortable: true, key: "customer_name" },
  // { id: 4, name: "Phone", isSortable: false, key: "phone" },
  { id: 5, name: "Venue Name", isSortable: true, key: "venue_name" },
  { id: 6, name: "Delivery Address", isSortable: true, key: "delivery_address" },
  { id: 8, name: "Booking Date", isSortable: true, key: "booking_date" },
  { id: 8, name: "Products", isSortable: false, key: "products" },
  { id: 12, name: "Balance", isSortable: true, key: "total_amount" },
  { id: 2, name: "Status", isSortable: false, key: "booking_status" },
  { id: 13, name: "Created", isSortable: true, key: "created_at" },
  { id: 33, name: "Deleted", isSortable: true, key: "deleted_at" },
  { id: 14, name: "Actions", isSortable: false, key: "actions" }
];


function Bookings() {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [data, setData] = useState<any[]>([]);
  const [pagination, setPagination] = useState<any>({current_page: 1, last_page: 1, per_page: 10, total: 0});

  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [restoreModal, setRestoreModal] = useState<boolean>(false);
  const [selectedItem, setSelectedItem] = useState<any>(null);
  
  const { filters, updateFilter } = useTableFilters();

  const fetchData = async () => {
    setIsLoading(true);
    const response = await getBookings(generateQueryParams(filters)+`&deleted=true`);
    if (response.success) {
      setData(response.data.items);
      setPagination(response.data.pagination);
    }
    setIsLoading(false);
  }

  useEffect(() => {
    fetchData();
  }, [filters]);

  const handleDeleteClick = (item) => {
    setSelectedItem(item);
    setDeleteModal(true);
  };

  const handleDeleteConfirm = async () => {
    if (selectedItem) {
      const response = await deleteBookingPermanently(selectedItem.id);
      if (response.success) {
        setDeleteModal(false);
        setSelectedItem(null);
        fetchData();
      }
    }
  };

  const onCloseClick = () => {
    setDeleteModal(false);
    setSelectedItem(null);
  };
  
    const handleRestoreClick = (item) => {
    setSelectedItem(item);
    setRestoreModal(true);
  };

  const handleRestoreConfirm = async () => {
    if (selectedItem) {
      const response = await restoreBooking(selectedItem.id);
      if (response.success) {
        setRestoreModal(false);
        setSelectedItem(null);
        fetchData();
      }
    }
  };

  const onClose = () => {
    setRestoreModal(false);
    setSelectedItem(null);
  };

  return (
    <>
    <div className="page-content">
      <Container fluid>
        <Breadcrumb items={[{ label: "Bookings" }]} />
        {isLoading ? <div className="position-relative vh-100"><Spinner/></div>
        :
        <Card>
          <CardBody>
            <PaginatedTable
              tableHead={tableHead}
              pagination={pagination}
              updateFilter={updateFilter}
              filters={filters}
              > 
              {data.length > 0 && data.map((item) => (
                <tr key={item.id}>
                  <td>{item.id}</td>
                  <td>
                    <div className="user-info">
                      <h5>{item?.customer?.name}</h5>
                      <p>{item?.customer?.email}</p>
                    </div>
                  </td>
                  {/* <td>{item?.customer?.phone_no_mobile}</td> */}
                  <td>{item?.delivery?.venue}</td>
                  <td>
                    <div className="user-info">
                      <h5>{item?.delivery?.complete_postcode}</h5>
                      <p>{item?.delivery?.town}</p>
                    </div>
                  </td>
                  <td>{convertDateFormat(item.booking_date)}</td>
                  <td>{item?.products?.length || 0}</td>
                  <td>{Number(item?.payments?.[0]?.total_amount).toFixed(2)}</td>
                  <td>{getStatusBadge("deleted")}</td>
                  <td>{convertDateFormat(item.created_at)}</td>
                  <td>{convertDateFormat(item.deleted_at)}</td>
                  <td>
                    <div>
                      <button className="btn btn-warning btn-sm me-1" onClick={() => handleRestoreClick(item)}><i className="mdi mdi-refresh"></i></button>
                      <button className="btn btn-danger btn-sm" onClick={() => handleDeleteClick(item)}><i className="mdi mdi-trash-can-outline"></i></button>
                    </div>
                  </td>
                </tr>))
              }
              {!isLoading && data.length === 0 && <tr className="text-center"><td colSpan={tableHead.length} className="text-danger">No Data Found</td></tr>}
            </PaginatedTable>
          </CardBody>
        </Card>
        }
      </Container>
    </div>
    {deleteModal && 
    <DeleteModal
      show={deleteModal}
      onDeleteClick={handleDeleteConfirm}
      onCloseClick={onCloseClick}
      message={`"${selectedItem?.customer?.name}" booking permanently`}
    />}
    {restoreModal &&
    <ConformationModal
      show={restoreModal}
      onConfirmClick={handleRestoreConfirm}
      onCloseClick={onClose}
      buttonText="Restore"
      textBefore = "restore"
      message={`"${selectedItem?.customer?.name}"`}
      textAfter='booking'
    />}
    </>
  );
}

export default Bookings;
